// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__2i7pT","row":"Option_row__DaFg4"};